module.exports = __webpack_public_path__ + "img/4-5.59596f5d.svg";